import { StepItemAnimationContainerProps } from '../types';

const StepItemAnimationContainer = ({
  children,
  activeStep,
  stopAnimating,
  direction,
}: StepItemAnimationContainerProps) => {
  const prevItem = activeStep - 1;
  const nextItem = activeStep + 1;

  const handleAnimationEnd = (e: any) => {
    if (e.currentTarget === e.target) {
      stopAnimating();
    }
  };

  // typescript fix
  if (!(children instanceof Array)) {
    return null;
  }

  // activeStep changes immediately, but need to keep prevItem/nextItem on page until animation completes
  return (
    <div className="relative w-full">
      {children?.map((item, i) => {
        if (i === prevItem && direction === 'forward') {
          return (
            <div key={`animstep${i}`} className="w-full step-left-animation absolute top-0">
              {item}
            </div>
          );
        } else if (activeStep === i) {
          return (
            <div
              key={`animstep${i}`}
              className={`w-full ${direction === 'back' ? 'step-from-left-animation' : ''}${
                direction === 'forward' ? 'step-from-right-animation' : ''
              }`}
              onAnimationEnd={handleAnimationEnd}
            >
              {item}
            </div>
          );
        } else if (i === nextItem && direction === 'back') {
          return (
            <div key={`animstep${i}`} className="w-full step-right-animation absolute top-0">
              {item}
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};

export default StepItemAnimationContainer;
